import React from 'react';
import {HashRouter} from 'react-router-dom';
import EnsureLoggedInPath from './components/EnsureLoggedInPath';
import TaskStatsView from './components/TaskStatsView';

export default class AppRouter extends React.Component {
  render() {
      return (<HashRouter>
        <div>
          <EnsureLoggedInPath exact path="/taskstats" component={TaskStatsView} />
        </div>
      </HashRouter>);
  }
}


// WEBPACK FOOTER //
// ./src/AppRouter.js